(function(){
    /* Ausgelagert (2026-09-17): Section-Root trägt data-alb-pdp-rabatt (+ Varianten-ID, Kaufart, optional Token) */
    var root = document.querySelector('[data-alb-pdp-rabatt]:not([data-alb-rv-init])');
    if (!root) return;
    root.setAttribute('data-alb-rv-init', '1');
    var CFG    = window.__albSf || {};
    var TOKEN  = root.getAttribute('data-alb-sf-token') || CFG.token || '%s';
    var DOMAIN = CFG.domain || location.hostname;
    var CUR    = CFG.currency || 'EUR';
    var API    = 'https://' + DOMAIN + '/api/2024-10/graphql.json';

    var buy   = root.querySelector('.alb-mp-buy') || root;
    var nowEl = buy.querySelector('[data-price-now]');
    var wasEl = buy.querySelector('[data-price-was]');
    var disc  = buy.querySelector('[data-disc-line]');
    var dPct  = buy.querySelector('[data-disc-pct]');
    var dName = buy.querySelector('[data-disc-name]');
    var dSep  = buy.querySelector('[data-disc-sep]');
    var dWas  = buy.querySelector('[data-disc-was]');
    var idInput = buy.querySelector('[data-variant-input]');
    if (!nowEl || !disc) return;
    /* Kaufoptionen-Karten (2026-10-06): Rabatt steht direkt im Kartenpreis statt nur in der
       (bei Abo-Produkten versteckten) Preiszeile. Abo nur, wenn der Code laut Shopify auch für
       Abos gilt (appliesOnSubscription) – der Test-Warenkorb trägt dafür die sellingPlanId. */
    var otCard  = buy.querySelector('[data-choose="onetime"] .pprice');
    var subCard = buy.querySelector('[data-choose="subscription"]');
    var subPriceBox = subCard ? subCard.querySelector('.pprice') : null;
    /* Rabattzeile (2026-10-06): „Rabattcode angewendet: <Code> −5 %“. Mit Kaufoptionen-Karten
       ohne Streichpreis (steht schon in der Karte), sonst bleibt er hinten nach dem Trenner. */
    var dPre = document.createElement('span');
    dPre.className = 'alb-mp-disc-pre';
    if (dName) dName.parentNode.insertBefore(dPre, dName);
    if (dPct){ if (dSep) dSep.parentNode.insertBefore(dPct, dSep); else disc.appendChild(dPct); }
    var showWas = !otCard;

    var Q = 'mutation cartCreate($input: CartInput!) {'
      + ' cartCreate(input: $input) {'
      + '   cart {'
      + '     cost { totalAmount { amount currencyCode } subtotalAmount { amount currencyCode } }'
      + '     discountAllocations { discountedAmount { amount } ... on CartAutomaticDiscountAllocation { title } ... on CartCodeDiscountAllocation { code } ... on CartCustomDiscountAllocation { title } }'
      + '     lines(first: 1) { nodes {'
      + '       cost { totalAmount { amount } amountPerQuantity { amount } }'
      + '       merchandise { ... on ProductVariant { price { amount } } }'
      + '       discountAllocations { discountedAmount { amount } ... on CartAutomaticDiscountAllocation { title } ... on CartCodeDiscountAllocation { code } ... on CartCustomDiscountAllocation { title } }'
      + '     } }'
      + '   }'
      + '   userErrors { field message }'
      + ' }'
      + '}';

    var cache = {}, inflight = {};
    var currentId = idInput && idInput.value ? String(idInput.value) : String(root.getAttribute('data-alb-variant') || '');
    var purchaseType = (root.getAttribute('data-alb-purchase') || 'onetime');

    function fmt(a){ return new Intl.NumberFormat('de-DE', { minimumFractionDigits:2, maximumFractionDigits:2 }).format(a) + ' ' + CUR; }

    function getActiveCodes(){
      return fetch('/cart.js', { headers: { 'Accept':'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var all = cart.discount_codes || [];
          var items = cart.items || [];
          if (items.length > 0){
            var applied = {};
            items.forEach(function(it){ (it.discounts||[]).forEach(function(d){ if (d.title) applied[String(d.title).toLowerCase()] = 1; }); });
            return all.filter(function(d){ /* Code im Warenkorb klein/groß beliebig (z. B. „thumann“ vs. Titel „THUMANN“) */ return d.applicable === true || applied[String(d.code).toLowerCase()]; }).map(function(d){ return d.code; });
          }
          return all.map(function(d){ return d.code; });
        })
        .catch(function(){ return []; });
    }

    var codesPromise = null;
    function codesP(){ if (!codesPromise) codesPromise = getActiveCodes(); return codesPromise; }

    function testDiscount(variantId, code, planId){
      var line = { quantity: 1, merchandiseId: 'gid://shopify/ProductVariant/' + variantId };
      if (planId) line.sellingPlanId = 'gid://shopify/SellingPlan/' + planId;
      var input = { lines: [line] };
      if (code) input.discountCodes = [code];
      return fetch(API, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
        body: JSON.stringify({ query: Q, variables: { input: input } })
      })
      .then(function(r){ return r.json(); })
      .then(function(j){
        var cc = j && j.data && j.data.cartCreate;
        if (!cc || !cc.cart || (cc.userErrors && cc.userErrors.length)) return null;
        var cart = cc.cart;
        var li = cart.lines && cart.lines.nodes && cart.lines.nodes[0];
        var all = (cart.discountAllocations || []).concat((li && li.discountAllocations) || []);
        var total = all.reduce(function(s, d){ return s + parseFloat(d.discountedAmount.amount); }, 0);
        return { code: code || null, cart: cart, li: li, all: all, total: total };
      })
      .catch(function(){ return null; });
    }

    function findBest(variantId, planId){
      return codesP().then(function(codes){
        if (codes.length){
          return Promise.all(codes.map(function(c){ return testDiscount(variantId, c, planId); })).then(function(res){
            var valid = res.filter(function(r){ return r && r.total > 0; });
            if (!valid.length) return null;
            return valid.reduce(function(a, b){ return a.total >= b.total ? a : b; });
          });
        }
        return testDiscount(variantId, null, planId).then(function(r){ return (r && r.total > 0) ? r : null; });
      });
    }

    function currentPlan(){
      if (!subCard) return '';
      var r = buy.querySelector('[data-plan-radio]:checked');
      return r ? String(r.value) : String(subCard.getAttribute('data-plan') || '');
    }

    function amounts(result){
      if (!result) return null;
      var li = result.li;
      // Abo: amountPerQuantity = Planpreis vor Rabatt; Einmalkauf: Variantenpreis
      var original = parseFloat((li && li.cost && li.cost.amountPerQuantity && li.cost.amountPerQuantity.amount)
        || (li && li.merchandise && li.merchandise.price && li.merchandise.price.amount)
        || result.cart.cost.subtotalAmount.amount);
      var discounted = parseFloat(result.cart.cost.totalAmount.amount);
      if (!(original > 0) || !(discounted < original)) return null;
      var label = '';
      if (result.all.length){ var d0 = result.all[0]; label = d0.title || d0.code || result.code || ''; }
      return { original: original, discounted: discounted, pct: Math.round((original - discounted) / original * 100), label: label, isCode: !!result.code };
    }

    // Kartenpreis: reduzierter Preis + Streichpreis. Die Basistexte schreibt
    // alb-main-product.js (Varianten-/Planwechsel) → hier nur Preistext + eigenes <s>.
    function cardPrice(box, a){
      if (!box) return;
      var now = box.querySelector('.pnow');
      var extra = box.querySelector('[data-card-disc-was]');
      var serverWas = box.querySelector('s:not([data-card-disc-was])');
      if (!a){
        if (extra) extra.remove();
        if (serverWas) serverWas.style.display = '';
        box.classList.remove('has-disc');
        return;
      }
      if (now) now.textContent = fmt(a.discounted);
      if (!extra){
        extra = document.createElement('s');
        extra.setAttribute('data-card-disc-was', '');
        if (now && now.nextSibling) box.insertBefore(extra, now.nextSibling); else box.appendChild(extra);
      }
      // Streichpreis = höherer Wert aus Server-Vergleichspreis (Abo: Einmalpreis) und Preis vor Code
      var wasVal = a.original;
      if (serverWas){
        var sv = parseFloat(serverWas.textContent.replace(/[^\d,]/g, '').replace(',', '.'));
        if (sv > wasVal) wasVal = sv;
        serverWas.style.display = 'none';
      }
      extra.textContent = fmt(wasVal);
      box.classList.add('has-disc');
    }

    function render(ot, sub){
      var aOt = amounts(ot), aSub = amounts(sub);
      cardPrice(otCard, aOt);
      cardPrice(subPriceBox, aSub);
      var isSub = purchaseType !== 'onetime';
      var a = isSub ? aSub : aOt;
      disc.setAttribute('data-has-disc', a ? '1' : '0');
      if (!a){
        disc.hidden = true;
        if (wasEl) wasEl.hidden = false;
      } else {
        nowEl.textContent = fmt(a.discounted);
        if (wasEl) wasEl.hidden = true;
        dPre.textContent = a.isCode ? 'Rabattcode angewendet:' : 'Rabatt angewendet:';
        dPct.textContent = '-' + a.pct + '%';
        if (a.label){ dName.textContent = a.label; dName.hidden = false; }
        else { dName.textContent = ''; dName.hidden = true; }
        if (dSep) dSep.hidden = !showWas;
        dWas.textContent = fmt(a.original);
        dWas.style.display = showWas ? '' : 'none';
        disc.hidden = false;
      }
      // Sticky-Kaufleiste zeigt den Einmalkauf-Preis → nur dessen Rabatt spiegeln
      broadcast(!isSub && aOt ? { id: currentId, price: fmt(aOt.discounted), was: fmt(aOt.original), pct: aOt.pct, label: aOt.label } : null);
    }

    function broadcast(payload){
      document.dispatchEvent(new CustomEvent('alb:discount', { detail: payload || { id: currentId, hasDiscount: false } }));
    }

    function get(id, plan){
      var key = id + '|' + (plan || '');
      if (cache[key] !== undefined) return Promise.resolve(cache[key]);
      if (!inflight[key]) inflight[key] = findBest(id, plan).then(function(r){ cache[key] = r; delete inflight[key]; return r; });
      return inflight[key];
    }

    var seq = 0;
    function run(){
      if (!currentId) return;
      var id = currentId, plan = currentPlan(), my = ++seq;
      Promise.all([get(id, ''), plan ? get(id, plan) : Promise.resolve(null)]).then(function(res){
        if (my !== seq) return; // inzwischen neue Auswahl
        render(res[0], res[1]);
      });
    }
    // Nach den Handlern von alb-main-product.js laufen (die schreiben die Basispreise zurück)
    function later(){ setTimeout(run, 0); }

    document.addEventListener('alb:variant-change', function(e){
      if (e.detail && e.detail.id != null){ currentId = String(e.detail.id); later(); }
    });
    document.addEventListener('alb:purchase-change', function(e){
      purchaseType = (e.detail && e.detail.type) || 'onetime';
      later();
    });
    buy.querySelectorAll('[data-plan-radio]').forEach(function(r){ r.addEventListener('change', later); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
